import { MILLISECONDS_IN_SECONDS } from 'src/Constants/numeric'

const STORAGE_KEY = 'pendingSpotifyReview'
const PENDING_TTL_MINUTES = 15
const SECONDS_IN_MINUTE = 60
const PENDING_TTL_MS =
  PENDING_TTL_MINUTES * SECONDS_IN_MINUTE * MILLISECONDS_IN_SECONDS

export const persistPendingSpotifyReview = (body: unknown): void => {
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ body, savedAt: Date.now() }),
  )
}

export const getPendingSpotifyReview = <T>(): T | null => {
  const raw = sessionStorage.getItem(STORAGE_KEY)
  if (!raw) {
    return null
  }

  const { body, savedAt } = JSON.parse(raw) as { body: T; savedAt: number }

  if (Date.now() - savedAt > PENDING_TTL_MS) {
    sessionStorage.removeItem(STORAGE_KEY)
    return null
  }

  return body
}

export const clearPendingSpotifyReview = (): void => {
  sessionStorage.removeItem(STORAGE_KEY)
}
